import React from "react";
import {Card} from "@mui/material";

interface StyledCardProps {
    children?: React.ReactNode;
    onClick?: (event: React.SyntheticEvent) => void;
}

const CardCustom = (props: StyledCardProps) =>
    <Card {...props} onClick={props.onClick}
          sx={{
              border: 3,
              borderColor: 'white',
              '&:hover': {
                  borderColor: '#db5f5a',
                  opacity: 1,
              },
              '&.Mui-selected': {
                  color: 'primary.main',
                  backgroundColor: 'secondary.main',
              },
          }}>
    </Card>

export default CardCustom;